import gql from 'graphql-tag';

export default gql`
  mutation groupMemberAdd($input: GroupMemberAddInput!) {
    groupMemberAdd(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
